import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withApollo } from 'react-apollo';

import Input from 'components/common/input';
import Button from 'components/common/button';
import Loader from 'components/common/loader';
import toast from 'components/common/toast';
import SmartLogo from 'static/smart-logo.png';

import USER_LOGIN from './requests';
import { LoginContainer, LoginCard, LogoContainer, LogoImage, LoaderContainer } from './elements';

// eslint-disable-next-line react/prefer-stateless-function
class Login extends Component {
  state = {
    login: {},
  };

  handleChange = e => {
    const { login } = this.state;
    const {
      target: { value, id },
    } = e;

    this.setState({ login: { ...login, [id]: value } });
  };

  handleSubmit = async e => {
    const { client } = this.props;
    const {
      login: { email, password },
    } = this.state;

    e.preventDefault();

    this.setState({ loading: true });
    const { data, errors } = await client.mutate({
      mutation: USER_LOGIN,
      variables: { email, password },
    });

    if (data.userLogin) {
      const { userLogin } = data;
      localStorage.setItem('userInventoryToken', userLogin.token);
      localStorage.setItem('userInventory', JSON.stringify(userLogin.user));
      window.location.reload();
    } else if (errors) {
      const [error] = errors;
      if (error.includes('Invalid user credentials.')) {
        toast.error('Usuario o contraseña invalidos');
      } else {
        toast.error('Algo salió mal, intentalo de nuevo');
      }
    }

    this.setState({ loading: false });
  };

  render() {
    const { loading } = this.state;
    return (
      <LoginContainer>
        <LoginCard>
          <LogoContainer>
            <LogoImage src={SmartLogo} />
          </LogoContainer>
          <form onSubmit={this.handleSubmit}>
            <Input
              input
              primary
              required
              type="email"
              label="Correo electrónico"
              id="email"
              marginB="10"
              onChange={this.handleChange}
            />
            <Input
              input
              primary
              required
              type="password"
              label="Contraseña"
              id="password"
              onChange={this.handleChange}
            />
            {loading ? (
              <LoaderContainer>
                <Loader />
              </LoaderContainer>
            ) : (
              <Button sm alignSelf="flex-end" marginT="20">
                Ingresar
              </Button>
            )}
          </form>
        </LoginCard>
      </LoginContainer>
    );
  }
}

Login.propTypes = {
  client: PropTypes.shape().isRequired,
};

export default withApollo(Login);
